// Caroussel3
var carouselWrap3 = $('.carrousel3'),
    carousel3 = $('.listItems', carouselWrap3),
    reinitTimer;

$('.item', carouselWrap3).clone().appendTo($('.listItems', carouselWrap3));

function carrousel3() {
    if (carouselWrap3.length > 0) {
        var itemHeight = carousel3[0].querySelector('.image-gallery-item__img').offsetHeight;

        if ($('.prevNextCaroussel3').length == 0) {
            carousel3.append('<ul class="prevNextCaroussel3">' +
                '<li class="prevCaroussel3"><button type="button" class="button-reset" style="height: ' + itemHeight + 'px;"><span class="ghost">' + l10n['prev'] + '</span></button></li>' +
                '<li class="nextCaroussel3"><button type="button" class="button-reset" style="height: ' + itemHeight + 'px;"><span class="ghost">' + l10n['next'] + '</span></button></li>' +
                '</ul>');
        }

        $(document, carousel3).on( 'cycle-initialized ', function( event, optionHash ) {
            carousel3.addClass('cycle-initialized');
        });

        carousel3.cycle({
            log: true,
            fx: 'carousel',
            allowWrap: false,
            carouselVisible: 1,
            carouselFluid: true,
            swipe: true,
            timeout: 0,
            //timeout: 4000,
            prev: '.prevCaroussel3 button',
            next: '.nextCaroussel3 button',
            slides: '.item',
            autoHeight: 'calc'
        });

        $('.item', carousel3).css('opacity', '1');
    }
}

var destroyCarrousel3 = function () {
    $('.carrousel3 .listItems').cycle('destroy');
    carousel3.removeClass('cycle-initialized');
}

function reinit_cycle3() {
    setTimeout(function () {
        destroyCarrousel3();
        setTimeout(function () {
            carrousel3();
        }, 200);
    }, 200);
}

function carrousel3State(view) {
    if (view === 'mediaDesktop') {
        destroyCarrousel3();
    } else if (view === 'mediaTablet') {
        destroyCarrousel3();
    } else if (view === 'mediaSmartphone') {
        clearTimeout(reinitTimer);
        reinitTimer = setTimeout(reinit_cycle3(), 200);
    }
}
